import React from 'react';
import type { LinkProps } from 'next/link';
import Link from 'next/link';
// eslint-disable-next-line camelcase
import type { Link_Reference_Relationship } from '../../graphql/generated/schema';
import { Link_Type } from '../../graphql/generated/schema';

// Next Link props
type Props = Omit<LinkProps, 'href'> & {
  link?: {
    // eslint-disable-next-line camelcase
    type?: Link_Type | null;
    url?: string | null;
    label?: string | null;
    // eslint-disable-next-line camelcase, @typescript-eslint/no-explicit-any
    reference?: Link_Reference_Relationship | any;
    newTab?: boolean;
  } | null;
  children?: React.ReactNode;
  className?: string;
  onFocus?: () => void;
}

export const AppLink: React.FC<Props> = ({
  link,
  children,
  className,
  ...rest
}) => {
  if (!link) return null;

  // eslint-disable-next-line camelcase
  if (link.type && link.type === Link_Type.Internal) {
    let pageSlug = link.reference?.value?.slug;
    if (pageSlug === 'home') {
      pageSlug = '';
    }

    let pageTypePath: string | null = null;
    switch (link.reference?.relationTo) {
      case 'page':
        pageTypePath = '';
        break;
      case 'service':
        pageTypePath = 'services';
        break;
      case 'lead_form':
        pageTypePath = 'form';
        break;
      case 'lead-form':
        pageTypePath = 'form';
        break;
      case 'article':
        if (typeof link.reference?.value === 'object' && 'categories' in link?.reference?.value) {
          pageTypePath = `articles/${link.reference?.value.categories?.[0]?.slug}`;
        }
        break;
      default:
        break;
    }

    return (
      <Link
        {...rest}
        href={`${pageTypePath ? `/${pageTypePath}` : ''}/${pageSlug}`}
        className={className}
        target={link.newTab ? '_blank' : undefined}
        rel={
          link.newTab ? 'noopener noreferrer' : undefined
        }
      >
        {
          children || link.label
        }
      </Link>
    );
  }

  return (
    <a
      {...rest}
      href={`${link?.url}`}
      className={className}
      target={link.newTab ? '_blank' : undefined}
      rel={
        link.newTab ? 'noopener noreferrer' : undefined
      }
    >
      {
        children || link.label
      }
    </a>
  );
};
